module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/pc/profile_page/primary_organization-680ddc8e93ab1c38dd5d0f33620f27c2.png";